import { CatalogsStoreEvents } from "./catalogs.store.events";
export const InMemoryCatalogsStoreTypeName = 'InMemoryCatalogsStore';
export class InMemoryCatalogsStore {
    constructor(eventBus) {
        this.items = {};
        this.eventBus = eventBus;
    }
    get(catalogName) {
        if (!catalogName) {
            throw new Error(InMemoryCatalogsStore.CATALOG_NAME_ERROR);
        }
        if (!this.items.hasOwnProperty(catalogName)) {
            return undefined;
        }
        return this.items[catalogName];
    }
    store(catalogName, catalog) {
        if (!catalogName) {
            throw new Error(InMemoryCatalogsStore.CATALOG_NAME_ERROR);
        }
        this.internalStore(catalogName, catalog);
        this.notifyDataChanged(catalogName, catalog);
    }
    clear(catalogName) {
        if (!catalogName) {
            throw new Error(InMemoryCatalogsStore.CATALOG_NAME_ERROR);
        }
        this.internalClear(catalogName);
        this.notifyDataChanged(catalogName);
    }
    async load(catalogName) {
        if (!catalogName) {
            throw new Error(InMemoryCatalogsStore.CATALOG_NAME_ERROR);
        }
        let item = undefined;
        if (!this.dataRequestCallback) {
            return item;
        }
        try {
            item = await this.dataRequestCallback(catalogName);
            this.internalStore(catalogName, item);
            return item;
        }
        catch (e) {
            console.error(e);
            throw new Error('Failed to load data from registered data request callback');
        }
    }
    onDataRequest(callback) {
        this.dataRequestCallback = callback;
    }
    register(context, catalogName, callback) {
        if (!catalogName) {
            throw new Error(InMemoryCatalogsStore.CATALOG_NAME_ERROR);
        }
        const eventName = this.getEventName(catalogName);
        return this.eventBus.registerBroadcast(this, InMemoryCatalogsStoreTypeName, eventName, (event) => {
            if (event.data) {
                callback.call(context, event.data.catalogName, event.data.catalog);
            }
        });
    }
    internalStore(catalogName, catalog) {
        this.internalClear(catalogName);
        if (catalog) {
            this.items[catalogName] = catalog;
        }
    }
    internalClear(catalogName) {
        if (this.items.hasOwnProperty(catalogName)) {
            delete this.items[catalogName];
        }
    }
    getEventName(catalogName) {
        return `${CatalogsStoreEvents.EVENT_NAME}${catalogName}`;
    }
    notifyDataChanged(catalogName, catalog) {
        const eventName = this.getEventName(catalogName);
        this.eventBus.dispatchBroadcast(InMemoryCatalogsStoreTypeName, eventName, {
            catalogName: catalogName,
            catalog: catalog
        });
    }
}
InMemoryCatalogsStore.CATALOG_NAME_ERROR = "Please provide a valid catalogName";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW4tbWVtb3J5LmNhdGFsb2dzLnN0b3JlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9zdG9yZXMvY2F0YWxvZ3MvaW4tbWVtb3J5LmNhdGFsb2dzLnN0b3JlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVNBLE9BQU8sRUFBZ0MsbUJBQW1CLEVBQUMsTUFBTSx5QkFBeUIsQ0FBQztBQUczRixNQUFNLENBQUMsTUFBTSw2QkFBNkIsR0FBRyx1QkFBdUIsQ0FBQztBQUVyRSxNQUFNLE9BQU8scUJBQXFCO0lBUTlCLFlBQW1CLFFBQW1CO1FBSnJCLFVBQUssR0FBb0MsRUFBRSxDQUFDO1FBS3pELElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDO0lBQzdCLENBQUM7SUFFTSxHQUFHLENBQUMsV0FBbUI7UUFDMUIsSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUNkLE1BQU0sSUFBSSxLQUFLLENBQUMscUJBQXFCLENBQUMsa0JBQWtCLENBQUMsQ0FBQztTQUM3RDtRQUNELElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxXQUFXLENBQUMsRUFBRTtZQUN6QyxPQUFPLFNBQVMsQ0FBQztTQUNwQjtRQUNELE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxXQUFXLENBQUMsQ0FBQztJQUNuQyxDQUFDO0lBRU0sS0FBSyxDQUFDLFdBQW1CLEVBQUUsT0FBb0M7UUFDbEUsSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUNkLE1BQU0sSUFBSSxLQUFLLENBQUMscUJBQXFCLENBQUMsa0JBQWtCLENBQUMsQ0FBQztTQUM3RDtRQUNELElBQUksQ0FBQyxhQUFhLENBQUMsV0FBVyxFQUFFLE9BQU8sQ0FBQyxDQUFDO1FBQ3pDLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxXQUFXLEVBQUUsT0FBTyxDQUFDLENBQUM7SUFDakQsQ0FBQztJQUVNLEtBQUssQ0FBQyxXQUFtQjtRQUM1QixJQUFJLENBQUMsV0FBVyxFQUFFO1lBQ2QsTUFBTSxJQUFJLEtBQUssQ0FBQyxxQkFBcUIsQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDO1NBQzdEO1FBQ0QsSUFBSSxDQUFDLGFBQWEsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUNoQyxJQUFJLENBQUMsaUJBQWlCLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDeEMsQ0FBQztJQUVNLEtBQUssQ0FBQyxJQUFJLENBQUMsV0FBbUI7UUFDakMsSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUNkLE1BQU0sSUFBSSxLQUFLLENBQUMscUJBQXFCLENBQUMsa0JBQWtCLENBQUMsQ0FBQztTQUM3RDtRQUNELElBQUksSUFBSSxHQUFnQyxTQUFTLENBQUM7UUFDbEQsSUFBSSxDQUFDLElBQUksQ0FBQyxtQkFBbUIsRUFBRTtZQUMzQixPQUFPLElBQUksQ0FBQztTQUNmO1FBQ0QsSUFBSTtZQUNBLElBQUksR0FBRyxNQUFNLElBQUksQ0FBQyxtQkFBbUIsQ0FBQyxXQUFXLENBQUMsQ0FBQztZQUNuRCxJQUFJLENBQUMsYUFBYSxDQUFDLFdBQVcsRUFBRSxJQUFJLENBQUMsQ0FBQztZQUN0QyxPQUFPLElBQUksQ0FBQztTQUNmO1FBQUMsT0FBTyxDQUFDLEVBQUU7WUFDUixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2pCLE1BQU0sSUFBSSxLQUFLLENBQUMsMkRBQTJELENBQUMsQ0FBQztTQUNoRjtJQUNMLENBQUM7SUFFTSxhQUFhLENBQUMsUUFBNEM7UUFDN0QsSUFBSSxDQUFDLG1CQUFtQixHQUFHLFFBQVEsQ0FBQztJQUN4QyxDQUFDO0lBRU0sUUFBUSxDQUFDLE9BQVksRUFBRSxXQUFtQixFQUFFLFFBQTRDO1FBQzNGLElBQUksQ0FBQyxXQUFXLEVBQUU7WUFDZCxNQUFNLElBQUksS0FBSyxDQUFDLHFCQUFxQixDQUFDLGtCQUFrQixDQUFDLENBQUM7U0FDN0Q7UUFDRCxNQUFNLFNBQVMsR0FBRyxJQUFJLENBQUMsWUFBWSxDQUFDLFdBQVcsQ0FBQyxDQUFDO1FBQ2pELE9BQU8sSUFBSSxDQUFDLFFBQVEsQ0FBQyxpQkFBaUIsQ0FBZ0MsSUFBSSxFQUFFLDZCQUE2QixFQUFFLFNBQVMsRUFBRSxDQUFDLEtBQTRDLEVBQUUsRUFBRTtZQUNuSyxJQUFJLEtBQUssQ0FBQyxJQUFJLEVBQUU7Z0JBQ1osUUFBUSxDQUFDLElBQUksQ0FBQyxPQUFPLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBQyxXQUFXLEVBQUUsS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQzthQUN0RTtRQUNMLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQUVPLGFBQWEsQ0FBQyxXQUFtQixFQUFFLE9BQXlCO1FBQ2hFLElBQUksQ0FBQyxhQUFhLENBQUMsV0FBVyxDQUFDLENBQUM7UUFDaEMsSUFBSSxPQUFPLEVBQUU7WUFDVCxJQUFJLENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxHQUFHLE9BQU8sQ0FBQztTQUNyQztJQUNMLENBQUM7SUFFTyxhQUFhLENBQUMsV0FBbUI7UUFDckMsSUFBSSxJQUFJLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxXQUFXLENBQUMsRUFBRTtZQUN4QyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLENBQUM7U0FDbEM7SUFDTCxDQUFDO0lBRU8sWUFBWSxDQUFDLFdBQW1CO1FBQ3BDLE9BQU8sR0FBRyxtQkFBbUIsQ0FBQyxVQUFVLEdBQUcsV0FBVyxFQUFFLENBQUM7SUFDN0QsQ0FBQztJQUVPLGlCQUFpQixDQUFDLFdBQW1CLEVBQUUsT0FBeUI7UUFDcEUsTUFBTSxTQUFTLEdBQUcsSUFBSSxDQUFDLFlBQVksQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUNqRCxJQUFJLENBQUMsUUFBUSxDQUFDLGlCQUFpQixDQUFnQyw2QkFBNkIsRUFBRSxTQUFTLEVBQUU7WUFDckcsV0FBVyxFQUFFLFdBQVc7WUFDeEIsT0FBTyxFQUFFLE9BQU87U0FDbkIsQ0FBQyxDQUFDO0lBQ1AsQ0FBQzs7QUE5RnNCLHdDQUFrQixHQUFHLG9DQUFvQyxDQUFDIn0=